import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AdminPortalProfileFieldModel,
  ProfileFieldType
} from 'src/app/admin/admin-home/admin-portal/admin-portal-model';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { PortalProfileModel } from 'src/portal/pages/portal-profile/portal-profile.models';
import { PersonEmailModel } from 'src/shared-app-portal/components/email-editor/person-email.model';

@Component({
  selector: 'app-portal-profile-system-fields',
  templateUrl: './portal-profile-system-fields.component.html',
  styleUrls: ['./portal-profile-system-fields.component.scss'],
  standalone: false
})
export class PortalProfileSystemFieldsComponent {
  constructor(private appConfigService: AppConfigService) {}

  @Output() verifyEmail = new EventEmitter<PersonEmailModel>();
  @Input() addEmailFn: (email: string) => Promise<boolean>;
  @Input() deleteEmailFn: (emailId: string) => Promise<boolean>;
  @Input() makePrimaryEmailFn: (email: PersonEmailModel) => Promise<boolean>;
  @Input() profile: PortalProfileModel;
  @Input() field: AdminPortalProfileFieldModel;
  ProfileFieldType = ProfileFieldType;
  get hasAddress(): boolean {
    if (!this.profile) return false;
    return !!(
      this.profile.streetAddress1 ||
      this.profile.streetAddress2 ||
      this.profile.city ||
      this.profile.postalCode ||
      this.profile.countryId ||
      this.profile.stateId ||
      this.profile.region
    );
  }

  get isPortalValidateAddress(): boolean {
    return this.appConfigService.tenant.portalConfiguration?.validateProfileAddress;
  }
}
